/* tslint:disable */
/* eslint-disable */
/* @relayHash b5816b8ec13f5e6a10fad7609837b804 */

import { ConcreteRequest } from "relay-runtime";
export type UpdateTranslationExerciseInput = {
    id: string;
    position?: number | null;
    content?: TranslationExerciseContentInput | null;
    clientMutationId?: string | null;
};
export type TranslationExerciseContentInput = {
    prompt: string;
    correctAnswers: Array<string>;
    scrambledParts: Array<string>;
};
export type UpdateTranslationExerciseMutationVariables = {
    input: UpdateTranslationExerciseInput;
};
export type UpdateTranslationExerciseMutationResponse = {
    readonly updateTranslationExercise: {
        readonly exercise: {
            readonly id: string;
            readonly content: {
                readonly prompt: string;
                readonly correctAnswers: ReadonlyArray<string>;
                readonly scrambledParts: ReadonlyArray<string>;
            };
        } | null;
    } | null;
};
export type UpdateTranslationExerciseMutation = {
    readonly response: UpdateTranslationExerciseMutationResponse;
    readonly variables: UpdateTranslationExerciseMutationVariables;
};



/*
mutation UpdateTranslationExerciseMutation(
  $input: UpdateTranslationExerciseInput!
) {
  updateTranslationExercise(input: $input) {
    exercise {
      id
      content {
        prompt
        correctAnswers
        scrambledParts
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateTranslationExerciseInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateTranslationExercise",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTranslationExercisePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "exercise",
        "storageKey": null,
        "args": null,
        "concreteType": "TranslationExercise",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "content",
            "storageKey": null,
            "args": null,
            "concreteType": "TranslationExerciseContent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "prompt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "correctAnswers",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "scrambledParts",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateTranslationExerciseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateTranslationExerciseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateTranslationExerciseMutation",
    "id": null,
    "text": "mutation UpdateTranslationExerciseMutation(\n  $input: UpdateTranslationExerciseInput!\n) {\n  updateTranslationExercise(input: $input) {\n    exercise {\n      id\n      content {\n        prompt\n        correctAnswers\n        scrambledParts\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'caacbda1210fd9ffed5a2420225d9601';
export default node;
